import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.body.addEventListener('htmx:beforeSwap', this.handleBeforeSwap.bind(this))
    document.body.addEventListener('htmx:afterSwap', this.handleAfterSwap.bind(this))
  }
  
  disconnect() {
    document.body.removeEventListener('htmx:beforeSwap', this.handleBeforeSwap.bind(this))
    document.body.removeEventListener('htmx:afterSwap', this.handleAfterSwap.bind(this))
  }
  
  initialize() {
    // Initialize any form elements if needed
  }
  
  handleBeforeSwap(event) {
    // Handle form validation errors
    if (event.detail.xhr.status === 422) {
      // Keep the modal open for errors
      event.detail.shouldSwap = true
      event.detail.target = this.element
    }
  }
  
  handleAfterSwap(event) {
    // Close modal on successful form submission
    if (event.detail.xhr.status === 200 && this.element.closest('.modal')) {
      $(this.element.closest('.modal')).modal('hide')
    }
  }
}
